import React from 'react';

const DeleteTestPopup = ({ show, onClose, onConfirm, testName = '' }) => {
    if (!show) {
        return null;
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
                <h2 className="text-xl font-bold text-red-600 mb-4">Delete Blood Test</h2>
                <p className="text-gray-700 mb-2">
                    Are you sure you want to delete {testName ? `"${testName}"` : 'this blood test'}?
                </p>
                <p className="text-gray-500 text-sm mb-6">
                    This action cannot be undone and all associated analysis will be lost.
                </p>
                <div className="flex justify-end space-x-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteTestPopup;
